/** Fasa 3 Perancangan (pelan P3-3b): dialog dan panel aliran kerja, penolakan Fasa 3 dan nama jenis jurnal baharu. */
export default {
  workflow: {
    dialog: {
      confirm: 'Sahkan',
      cancel: 'Batal',
      optional: 'pilihan',
      required: 'Wajib diisi.',
      choose: 'Pilih…',
      yes: 'Ya',
      no: 'Tidak',
      notRecorded: 'Tidak direkodkan',
      days: 'hari',
      effectiveHint: 'Tarikh ini berkuat kuasa: hari ini, atau paling lewat 30 hari ke belakang.',
      numberHint: 'Dicadangkan mengikut format penomboran. Ubah sebelum mengesahkan jika surat membawa nombor lain.',
      listMissing: 'Senarai ini belum tersedia.',
      invalid: 'Beberapa nilai ditolak:',
      reason: 'Sebab',
      agencies: 'Agensi untuk dirujuk',
      agenciesHint: 'Satu rujukan dihantar kepada setiap agensi, dengan tempoh ulasan edaran ini.',
      agenciesRequired: 'Pilih sekurang-kurangnya satu agensi.',
      agencyOpen: 'sudah dirujuk',
      drawing: 'Lukisan',
      drawingSame: 'Gunakan lukisan yang sudah ada pada kes',
      drawingSameHint: 'Lukisan terkini disemak semula sebagai versi seterusnya.',
      drawingReplace: 'Muat naik lukisan pindaan',
      drawingReplaceHint: 'Lukisan baharu menjadi versi seterusnya.',
      drawingNoPrevious: 'Tiada lukisan terdahulu untuk diguna semula, jadi muat naik satu.',
      uploading: 'Memuat naik lukisan… {{percent}}%',
      finalizing: 'Menyemak muat naik…',
      submitting: 'Menyimpan…',
    },
    kinds: { internal: 'Jabatan majlis', external: 'Agensi luar' },
    conditions: {
      add: 'Tambah syarat',
      fromLibrary: 'Tambah daripada pustaka',
      chooseTemplate: 'Pilih syarat pustaka…',
      pCode: 'Peringkat pematuhan',
      text: 'Syarat',
      remove: 'Buang',
      none: 'Belum ada syarat.',
      max: 'Paling banyak {{max}} syarat.',
      code: 'Kod pustaka {{code}}',
      noOpen: 'Semua syarat telah dipatuhi.',
      digestOnly:
        '{{number}} daripada syarat kes ini diterima daripada sistem lain tanpa teksnya dan tidak dapat dipaparkan di sini. Mengesahkan akan menggantikan syarat kes dengan senarai di bawah, jadi tambahkan semula syarat itu daripada surat asal terlebih dahulu.',
    },
    decision: {
      title: 'Keputusan dan syarat',
      number: 'Nombor keputusan {{number}}, dikeluarkan {{date}}',
      noNumber: 'Belum ada nombor keputusan dikeluarkan.',
      conditions: 'Syarat-syarat',
      noConditions: 'Tiada syarat direkodkan.',
      textAbsent: 'Teks syarat ini disimpan oleh sistem yang menghantar kes.',
      complied: 'Dipatuhi',
      open: 'Belum dipatuhi',
      preGrant: 'Sebelum kebenaran',
    },
    flags: { title: 'Fakta yang direkodkan', counters: 'Kiraan' },
    referrals: {
      title: 'Rujukan',
      round: 'Pusingan {{round}}',
      requested: 'Dirujuk {{date}}',
      due: 'Ulasan perlu sebelum {{date}}',
      overdue: 'Tempoh telah lepas',
      late: 'Jawapan lewat',
      answered: 'Dijawab {{date}}',
      status: { open: 'Menunggu ulasan', answered: 'Dijawab', withdrawn: 'Ditarik balik' },
      none: 'Belum ada rujukan.',
      request: 'Minta rujukan',
      requestTitle: 'Minta rujukan',
      requestHint: 'Setiap agensi diberi tempoh ulasan edaran terkini.',
      answer: 'Rekod jawapan',
      answerTitle: 'Jawapan daripada {{agency}}',
      outcome: 'Jawapan',
      answeredOn: 'Tarikh jawapan',
      deemedHint:
        'Tempoh ulasan telah lepas. Rekod jawapan dianggap hanya selepas menyemak bahawa OSC 3.0 Plus tidak menyimpan sebarang jawapan.',
      conditionsRequired: 'Keperluan memerlukan sekurang-kurangnya satu syarat.',
      withdraw: 'Tarik balik',
      withdrawTitle: 'Tarik balik rujukan kepada {{agency}}',
      withdrawBody: 'Agensi itu tidak lagi diminta mengulas. Jawapan yang sudah dihantar kekal pada kes.',
      outcomes: {
        requirements: 'Ada keperluan',
        no_requirements: 'Tiada keperluan',
        deemed: 'Dianggap: tiada jawapan',
      },
      departmentNote: 'Hanya rujukan kepada jabatan anda dipaparkan.',
      letterHint:
        'Failkan surat agensi di bawah Dokumen lain pada kes ini: jawapan di sini hanya merekodkan keputusan dan syaratnya.',
    },
    links: {
      title: 'Kes berpaut',
      none: 'Tiada kes berpaut.',
      relations: { km: 'Kebenaran merancang (KM)' },
      kinds: { case: 'Kes dalam sistem ini', reference: 'Rujukan luar', exemption: 'Pengecualian' },
      parentAbsent: 'Kes berpaut tidak disimpan dalam pemasangan ini.',
      reference: 'Rujukan {{reference}}',
      validity: 'Dikeluarkan {{issued}}, sah hingga {{until}}',
      link: 'Pautkan {{relation}}',
      linkTitle: 'Pautan: {{relation}}',
      unlink: 'Buang pautan',
      unlinkTitle: 'Buang pautan {{relation}}',
      unlinkBody: 'Pautan dibuang daripada kes ini. Kes yang satu lagi tidak diubah.',
      target: 'Pautkan kepada',
      searchLabel: 'Cari kes',
      searchPlaceholder: 'Rujukan atau nama projek',
      search: 'Cari',
      noResults: 'Tiada kes sepadan.',
      chosen: 'Dipilih: {{caseRef}}',
      referenceLabel: 'Rujukan',
      issuedOn: 'Tarikh dikeluarkan',
      validUntil: 'Sah hingga',
      chooseCase: 'Pilih satu kes dahulu.',
    },
    documents: {
      title: 'Dokumen lain',
      none: 'Belum ada dokumen lain.',
      revision: 'Versi {{revision}}',
      shared: 'Dipaparkan kepada pemohon',
      upload: 'Muat naik dokumen',
      uploadTitle: 'Muat naik dokumen',
      type: 'Jenis dokumen',
      file: 'Fail',
      fileHint: '{{extensions}}, sehingga {{max}} MB.',
      share: 'Paparkan dokumen ini kepada pemohon',
      shareHint: 'Pilihan ini tidak boleh diubah selepas dimuat naik.',
      fileMissing: 'Pilih satu fail.',
      fileType: 'Pilih fail {{extensions}}.',
      fileEmpty: 'Fail itu kosong.',
      fileTooLarge: 'Fail itu melebihi {{max}} MB.',
      uploading: 'Memuat naik… {{percent}}%',
      finalizing: 'Menyemak muat naik…',
      download: 'Muat turun',
      downloadLabel: 'Muat turun {{name}}',
      added: 'Dokumen ditambah',
      rejected: 'Dokumen ditolak ({{reason}}).',
    },
    department: {
      listTitle: 'Kes yang dirujuk kepada jabatan anda',
      listSubtitle: 'Kes perancangan yang rujukannya dijawab oleh jabatan anda.',
      empty: 'Tiada kes dirujuk kepada jabatan anda.',
      detailNote:
        'Anda boleh melihat kes ini kerana ia dirujuk kepada jabatan anda. Jawab rujukan jabatan anda di bawah.',
    },
    issues: {
      unknownKey: 'Nilai yang tidak diterima oleh tindakan ini telah dihantar',
      reasons: {
        missing: 'wajib diisi',
        type: 'bukan nilai yang sah',
        range: 'di luar julat yang dibenarkan',
        too_long: 'terlalu panjang',
        duplicate: 'diberi dua kali',
        unknown_code: 'tiada dalam senarai',
        unknown_condition: 'bukan salah satu syarat kes',
        future: 'pada masa hadapan',
        too_old: 'melebihi 30 hari ke belakang',
        before_previous_event: 'sebelum langkah terakhir yang direkodkan pada kes',
        unknown_key: 'tidak diterima oleh tindakan ini',
      },
    },
    keys: {
      agencies: 'Agensi-agensi',
      agency: 'Agensi',
      referralId: 'Rujukan',
      outcome: 'Jawapan',
      answeredOn: 'Tarikh jawapan',
      conditions: 'Syarat',
      targetCaseId: 'Kes berpaut',
      external: 'Rujukan luar',
      relation: 'Pautan',
      linkId: 'Pautan',
      windowDays: 'Tempoh ulasan',
      kind: 'Jenis',
      reason: 'Sebab',
    },
  },
  guards: {
    separation_of_duties_required: 'orang yang menulis perakuan atau menghantar terakhir tidak boleh membuat keputusan',
    referrals_settled: 'beberapa rujukan pusingan ini belum dijawab',
    check_latest_failed_overridable: 'semakan gagal terkini tidak boleh diterima dengan pengecualian',
    check_latest_passed_or_accepted: 'semakan terkini belum lulus dan tidak diterima',
    input_date_not_after_clock_due: 'tarikh tidak boleh selepas tarikh akhir',
    link_present: 'kes belum dipautkan kepada kebenaran merancangnya',
    link_parent_valid: 'kebenaran merancang yang dipautkan belum diberi atau tidak lagi sah',
    constraints_determined: 'pegawai perlu memutuskan dapatan kekangan dahulu',
    rules_determined: 'pegawai perlu memutuskan keputusan peraturan dahulu',
  },
  errors: {
    input_invalid: 'Beberapa nilai ditolak. Betulkan medan yang ditanda di bawah dan cuba lagi.',
    condition_not_met:
      'Tindakan ini tidak lagi terpakai pada kes seperti keadaannya sekarang. Muat semula halaman untuk melihat tindakan yang boleh diambil.',
    decision_number_taken: 'Nombor keputusan itu sudah digunakan oleh kes lain. Masukkan nombor lain.',
    no_referrals: 'Prosedur kes ini tidak mempunyai rujukan.',
    referral_not_found: 'Rujukan itu tiada pada kes ini, atau bukan untuk anda jawab.',
    referral_exists: 'Agensi itu sudah mempunyai rujukan terbuka pada kes ini.',
    referral_closed: 'Rujukan itu sudah dijawab atau ditarik balik.',
    referral_not_due: 'Tempoh ulasan belum lepas, jadi jawapan dianggap belum boleh direkodkan.',
    relation_unknown: 'Prosedur kes ini tidak membenarkan pautan itu.',
    link_exists: 'Kes ini sudah dipautkan untuk tujuan itu. Buang pautan itu dahulu.',
    link_not_found: 'Pautan itu tiada lagi pada kes ini.',
    referral_requests_closed: 'Rujukan baharu ditutup: jawatankuasa telah membuat keputusan bagi kes ini.',
    referral_window_unknown: 'Edarkan kes dahulu: rujukan mengambil tempoh ulasannya daripada edaran.',
    link_target_not_found: 'Kes itu tidak ditemui, atau anda tidak boleh melihatnya.',
    link_kind_mismatch:
      'Sesuatu kes hanya dipautkan kepada induk daripada jenis yang dinamakan oleh pautan, bukan kepada jenisnya sendiri.',
  },
  events: {
    referral_requested: 'Rujukan dihantar',
    referral_answered: 'Rujukan dijawab',
    referral_withdrawn: 'Rujukan ditarik balik',
    case_linked: 'Kes dipautkan',
    case_unlinked: 'Pautan kes dibuang',
    check_exceptions_accepted: 'Semakan pelan diterima',
  },
} as const
